import React, { useState, useEffect } from "react";
import { Link, Redirect } from "react-router-dom";
import StyledFirebaseAuth from "react-firebaseui/StyledFirebaseAuth";
import firebase from "../../../firebase";
import queryString from "query-string";
import userStore from "../../../Stores/User";

import mixpanel from "mixpanel-browser";
import { observer } from "mobx-react";
import loadingIcon from "../../../Assets/loading.gif";

const CreateAccount = observer((props) => {
  const params = queryString.parse(props.location.search);
  const app = params.app;
  const [shouldRedirect, setShouldRedirect] = useState(false);
  const [redirectTo, setRedirectTo] = useState("ChooseVoice");
  const { user, firebaseUser, idToken, creditsHd, vipId} = userStore;


  // useEffect(() => {
  //   // HACK: probably better to fire this in Signin or User.js
  //   // Print this object as a string so we can see what's going on
  //   alert(JSON.stringify(firebaseUser));
  // }, [firebaseUser]);

  useEffect(() => {

    if (user) {
      setShouldRedirect(true);
    }
  }, [user, vipId]);

  if (shouldRedirect) {
    return <Redirect to={`${redirectTo}?app=${app}`} />;
  }

  const uiConfig = {
    signInFlow: app === "ios" ? "redirect" : "popup",
    // signInFlow: "popup",
    signInOptions: [
      firebase.auth.GoogleAuthProvider.PROVIDER_ID,
      firebase.auth.EmailAuthProvider.PROVIDER_ID,
    ],
    callbacks: {
      signInSuccess: () => false,
    },
  };

  return (
    <div className="center-static">
      {firebaseUser === null || user === null ? (
        <>
          <h1 className="headline">Let's create an account</h1>
          <h1 className="subheadline">
            Securely access your account from any device
          </h1>
        </>
      ) : (
        <>
          <h1 className="headline">Creating an account...</h1>
          <h1 className="subheadline">This should only take a few seconds</h1>
        </>
      )}
      {/* <h2 className="subheadline">
        Access your feed on the web, iOS/Android apps, and Chrome extension
      </h2> */}

      <div style={{ marginTop: "50px" }}>
        {firebaseUser === null || user === null  ? (
          <StyledFirebaseAuth
            uiConfig={uiConfig}
            firebaseAuth={firebase.auth()}
          />
        ) : (
          <img src={loadingIcon} style={{ height: "50px" }} alt="loading..." />
        )}
      </div>
      {/* <div>
          {`USER:` + JSON.stringify(user)}

      </div>
      <div>
      {`FIREBASE USER:` + JSON.stringify(firebaseUser)}

      </div> */}
    </div>
  );
});

export default CreateAccount;
